/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    numberTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.#',
        defaultMessage: '#'
    },
    yearTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.Year',
        defaultMessage: 'Year'
    },
    brandTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.Brand',
        defaultMessage: 'Brand'
    },
    lengthTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.Length',
        defaultMessage: 'Length'
    },
    serialNumberTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.Serial #',
        defaultMessage: 'Serial #'
    },
    valueTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.Value ($)',
        defaultMessage: 'Value ($)'
    },
    addTenderDinghyBoat: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.Add Tender Dinghy Boat',
        defaultMessage: 'Add Tender Dinghy Boat'
    },
    add: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.AddButton',
        defaultMessage: 'Add'
    },
    removeTenderDinghyBoat: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.TenderDinghyBoats.Remove Tender Dinghy Boat',
        defaultMessage: 'Removed Tender Dinghy Boat {brandDesc}'
    }
});